import vitruviusImmutable from '@americanexpress/vitruvius/immutable';
import authReducer from '@americanexpress/one-identity-ducks';
import productsReducer from '@americanexpress/product-ducks';
import { resourcesReducer } from 'iguazu-rest';
import { proceduresReducer } from 'iguazu-rpc';
import core from './core';

export default vitruviusImmutable({
  core,
  procedures: proceduresReducer,
  resources: resourcesReducer,
  products: productsReducer,
  auth: authReducer,
});
